<!-- Todo: Add CMS labels -->
<div class="flex flex-col gap-10 h-full">
    <p class="text-2xl/7 font-bold text-[#333333]">Enter your email</p>
    <div class="flex flex-col gap-2 h-full">
        
        <form [formGroup]="emailForm" class="h-full flex flex-col justify-between">
            <div class="flex flex-col gap-6">
                <div class="flex flex-col gap-2 border-solid border-[#B3B3B3] border-t-0 border-r-0 border-b-[1px] border-l-0 py-1">
                    <label class="text-xs font-medium text-[#737373]" for="email-input">Email</label>
                    <input [formControlName]="'email'" class="border-none w-full text-base font-['Roboto'] focus:outline-none text-[#333333]" type="email" id="email-input"/>
                </div>
                <div *ngIf="emailForm.get('email')?.valid" class="flex flex-col gap-2 border-solid border-[#B3B3B3] border-t-0 border-r-0 border-b-[1px] border-l-0 py-1">
                    <label class="text-xs font-medium text-[#737373]" for="confirmEmail-input">Re-enter email</label>
                    <input [formControlName]="'confirmEmail'" class="border-none w-full text-base font-['Roboto'] focus:outline-none text-[#333333]" [ngClass]="{'text-[#DA291C]': !doEmailsMatch() && emailForm.get('confirmEmail')?.touched}" type="email" id="email-input"/>
                </div>
                <div *ngIf="((emailForm.touched || emailForm.dirty) || emailForm.get('confirmEmail')?.valid) && !emailFieldsAreEmpty()">
                    <div class="flex gap-[9px] font-bold text-xs/6">
                        <img
                            [src]="doEmailsMatch() ? 'assets/images/green-confirmation-circle.svg' : 'assets/images/red-exclamation-circle.svg'"
                            [alt]="doEmailsMatch() ? 'green confirmation icon' : 'red error exclamation icon'"
                        />
                        <span *ngIf="doEmailsMatch(); else mismatch" class="text-[#008A00]">Emails match</span>
                        <ng-template #mismatch>
                            <span class="text-[#DA291C]">Emails don't match</span>
                        </ng-template>
                    </div>
                </div>
            </div>
            <button [disabled]="emailForm.invalid && !doEmailsMatch()" (click)="submitEmailForm()" [ngClass]="{'sign-in-disabled-btn-filled': emailForm.invalid || !doEmailsMatch(), 'sign-in-red-btn-filled': emailForm.valid}" class="mb-14">Continue</button>
        </form>
    </div>
</div>
